import { h, render, hydrate } from 'preact';
import './styles/main.scss';
import { BoostPage } from './pages/BoostPage';
const mountElement = document.getElementById('search-app');
if (mountElement) {
    console.log('reviews.io PLP work');
    // console.log('[search-app] dataset:', { ...mountElement.dataset });
    const dataset = mountElement.dataset;
    let bannerConfig;
    if (dataset.bannerImage) {
        bannerConfig = {
            image: dataset.bannerImage,
            heading: dataset.bannerHeading || '',
            buttonText: dataset.bannerButtonText || undefined,
            buttonLink: dataset.bannerButtonLink || undefined,
            isWide: dataset.enableWideBanner === 'true',
            position: Math.max(1, parseInt(dataset.bannerPosition || '1', 10) || 1),
        };
    }
    if (mountElement.hasChildNodes()) {
        hydrate(h(BoostPage, { bannerConfig: bannerConfig }), mountElement);
    }
    else {
        render(h(BoostPage, { bannerConfig: bannerConfig }), mountElement);
    }
}
